import { Alert, styled } from '@mui/material';

import type { ChkAlertProps } from './ChkAlert.types';

export const ChkAlert = ({ big = false, children, ...rest }: ChkAlertProps) => {
  return (
    <StyledAlert big={big} {...rest}>
      {children}
    </StyledAlert>
  );
};

const StyledAlert = styled(Alert, {
  shouldForwardProp: (prop) => prop !== 'big',
})<{ big: ChkAlertProps['big'] }>(({ big, theme }) => ({
  display: 'flex',
  flexDirection: big ? 'column' : 'row',
  alignItems: 'center',
  padding: big ? theme.spacing(6, 4) : theme.spacing(4, 3),
  textAlign: big ? 'center' : 'left',
  border: theme.borders.borderWidth1,
  borderRadius: theme.borders.borderRadius2,
  color: theme.tokens.additionalInfoValueDefault,

  '&.MuiAlert-standardInfo': {
    backgroundColor: theme.tokens.additionalInfoBackgroundInfo,
    borderColor: theme.tokens.additionalInfoBorderInfo,
  },

  '&.MuiAlert-standardError': {
    backgroundColor: theme.tokens.additionalInfoBackgroundWarning,
    borderColor: theme.tokens.additionalInfoBorderWarning,
  },

  '.MuiAlert-icon, .MuiAlert-message': {
    padding: 0,
    display: big ? 'static' : 'flex',
    letterSpacing: 0,
  },

  '.MuiAlert-icon': {
    alignSelf: big ? 'initial' : 'flex-start',
    padding: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
}));
